/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */

/**
 * License period. Null when the underlying value is missing or does not match a known enum member.
 */
export type LicenseDuration = (typeof LicenseDuration)[keyof typeof LicenseDuration];

export const LicenseDuration = {
  "12_months": "12 months",
  Until_end_of_current_year: "Until end of current year",
  "1_time": "1 time",
  Specific_time: "Specific time",
  "3_months": "3 months",
  "1_month": "1 month",
} as const;
